import axios from "axios";
import { API_BASE_URL } from "../config/api";
import { actorHeaders } from "./actor";

// The AI Analyst chat (components/features/chat/ChatPanel). A plain axios
// call, not apiClient, with the acting team member's header added by hand.

// VITE_API_BASE, when set, overrides the shared backend base for chat only.
const API_BASE = import.meta.env.VITE_API_BASE || API_BASE_URL;

export interface ChatQuery {
  question: string;
  history: Array<{ role: string; content: string }>;
  session_id: string;
}

/** Ask the chat backend one question; rejects with the axios error. */
export const postChatQuery = (query: ChatQuery) =>
  axios.post(`${API_BASE}/chat/query`, query, { headers: actorHeaders() });
